/** Wording for the stock-validation wizard — written for an investor deciding on a listed stock. */
export const stockValidationCopy = {
  title: 'Validate a stock',
  subtitle:
    'Enter where the stock trades and its symbol. Vibelin researches the company from public information, stage by stage, and ends with a buy, hold or sell summary.',
  stock: {
    heading: 'Which stock?',
    helper: 'The exchange the shares trade on and the ticker symbol, as shown on the exchange or a finance site.',
    exchangeLabel: 'Exchange',
    exchangePlaceholder: 'NASDAQ',
    symbolLabel: 'Stock symbol',
    symbolPlaceholder: 'AAPL',
    symbolInvalid: 'Letters, digits, dots and dashes only, up to 12 characters.',
  },
  /** Common exchanges offered as suggestions; any other name can be typed. */
  exchanges: [
    'NASDAQ',
    'NYSE',
    'NYSE American',
    'London Stock Exchange (LSE)',
    'Euronext Paris',
    'Euronext Amsterdam',
    'Deutsche Börse Xetra',
    'SIX Swiss Exchange',
    'Toronto Stock Exchange (TSX)',
    'Tokyo Stock Exchange (TSE)',
    'Hong Kong Stock Exchange (HKEX)',
    'Shanghai Stock Exchange (SSE)',
    'National Stock Exchange of India (NSE)',
    'Australian Securities Exchange (ASX)',
    'Tel Aviv Stock Exchange (TASE)',
  ],
  start: 'Start validation',
  startHint:
    'Creates the project, named from the symbol and the exchange, and generates the first stage, Company Snapshot. You follow the progress on the next screen.',
} as const;
